/* eslint-disable no-param-reassign */
import React, { useCallback } from 'react'

import Flicking from '@egjs/react-flicking'
import { useEffectOnce } from 'react-use'

import useResizeEventHandler from '@web/hooks/useResizeEventHandler'
import { isHTMLElement } from '@web/libs/utils'

const useChangeAlign = (
  wrapperRef: React.RefObject<HTMLDivElement>,
  flickingRef: React.RefObject<Flicking>,
  alignLeftFocusCenter?: boolean,
) => {
  const changeAlign = useCallback(() => {
    if (!alignLeftFocusCenter) return

    if (!wrapperRef.current || !flickingRef.current) return

    const lastChild = flickingRef.current.camera?.element?.lastElementChild

    if (!lastChild) return

    if (!isHTMLElement(lastChild)) return

    const visible = wrapperRef.current.clientWidth > lastChild.offsetLeft + lastChild.offsetWidth
    const nextAlign = visible ? 'prev' : 'center'

    if (flickingRef.current.align !== nextAlign) {
      flickingRef.current.align = nextAlign
      flickingRef.current.forceUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffectOnce(changeAlign)
  useResizeEventHandler(changeAlign, [])
}
export default useChangeAlign
